'use client';

import { useMemo } from 'react';
import { MatchQuery } from '@opensearch-project/opensearch/api/_types/_common.query_dsl';

import { useDispensaryTimeZone } from '@/hooks';

import { buildOnSaleQueryFilter as buildOnSaleQueryFilterFor } from '../../constants';
import { buildFacetQueryFilters as buildFacetQueryFiltersFor } from '../../utils';

/**
 * Returns the `build*QueryFilter` helpers with the selected store's timezone
 */
export const useQueryFilterBuilders = () => {
  const timeZone = useDispensaryTimeZone();

  return useMemo(
    () => ({
      buildFacetQueryFilters: (facet: string, values: MatchQuery[]) =>
        buildFacetQueryFiltersFor(facet, values, timeZone),
      buildOnSaleQueryFilter: () => buildOnSaleQueryFilterFor(timeZone),
    }),
    [timeZone],
  );
};
